import { useCallback, useState } from 'react'

import { LoaderOverlay } from 'cng-common/components/loaderOverlay'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'
import { Controller } from 'core-components/library/validation'
import { IQBRDocumentsListItem } from 'partner360/models/qbr/IQBRDocumentsListItem'

import { TRANSLATION_KEYS } from '../../../../translations'
import { deleteVersion } from '../../helpers/deleteQbrItem'

import styles from './QbrDeleteVersionContent.module.scss'

interface IProps {
  selectedVersion: IQBRDocumentsListItem
  closeDialog: () => void
  qbrDocumentsData: IQBRDocumentsListItem[]
  setQbrDocumentsData: (value: IQBRDocumentsListItem[]) => void
  setInitialData: (value: IQBRDocumentsListItem[]) => void
}

export const QbrDeleteVersionContent = ({
  selectedVersion,
  closeDialog,
  qbrDocumentsData,
  setQbrDocumentsData,
  setInitialData,
}: IProps) => {
  const [wip, setWip] = useState(false)

  const onDelete = useCallback(async () => {
    setWip(true)
    await deleteVersion(selectedVersion.EntryId)
    const filteredArray = qbrDocumentsData.filter((el) => el.EntryId !== selectedVersion.EntryId)
    setQbrDocumentsData(filteredArray)
    setInitialData(filteredArray)
    setWip(false)
    closeDialog()
  }, [setInitialData, selectedVersion, closeDialog, qbrDocumentsData, setQbrDocumentsData])

  return (
    <Controller>
      <div className={styles.root}>
        <LoaderOverlay isVisible={wip} />
        <div className={styles.title}>
          <Translation text={TRANSLATION_KEYS.buttons.deleteRecordButtonConfirm} />
        </div>
        <div className={styles.btnWrapper}>
          <Button onClick={onDelete}>
            <Translation text={TRANSLATION_KEYS.buttons.deleteRecordButton} />
          </Button>
        </div>
      </div>
    </Controller>
  )
}
